/*
* Created By : Sajeel Shafqat
* Company : Teknologics
* Created Date : 20-Oct-2023
*
* All new js script updates after created date will be done in this file.
* 
*/

/*Collection page - product name in two lines*/
/*
jQuery(document).ready(function(){
  sg_sel1='#home-skin .halo-block-content  a[data-product-title="Pava Toner"][tabindex="0"] span';
  sg_sel2='#home-skin .halo-block-content  a[data-product-title="Irie Power Face Oil"][tabindex="-1"] span';
 // sg_txt1 = jQuery(sg_sel1).text().trim().replace(" ", "<br>");
 // sg_txt2 = jQuery(sg_sel2).text().trim().replace("Irie Power Face Oil", "Irie Power Face<br>Oil");
  jQuery(sg_sel1).html('Pava<br>Toner');
  jQuery(sg_sel2).html('Irie Power Face<br>Oil');
    
}); */


  $(document).ready(function() {
  function splitLastOccurrence(str, substring) {
    const lastIndex = str.lastIndexOf(substring);
    const before = str.slice(0, lastIndex);
    const after = str.slice(lastIndex + 1);
    return [before, after];
  }

  jQuery('#shop-all-skin .halo-block-content a span,#home-skin .halo-block-content a span').each(function() {
    if(jQuery(this).text().trim().length < 24){
         const [before, after] = splitLastOccurrence(jQuery(this).text().trim(),' ');
       jQuery(this).html(before + '<br>' + after);
    }  
  });
});
/*SJS link on the video*/
jQuery(document).ready(function(){
  let tek_video_lk = jQuery('.Video-Section .video-text a').attr('href');
  if(tek_video_lk){
  	jQuery('.Video-Section video').click(function(){
  		window.location = tek_video_lk;
  	});
  }
});  

jQuery(document).ready(function(){
  
    jQuery(".link-view").css("color", "#795D50");
    jQuery(".link-view").click(function(){
      jQuery(this).css("color", "#795D50");
      jQuery(".tek-flex-item :not(.link-view)").css("color", "#696969");
      jQuery(".prod-essentials").show();
      jQuery("prod-tools").show();
      jQuery(".prod-sets").show();
    });
    jQuery(".link-sets").click(function(){
      jQuery(this).css("color", "#795D50");
      jQuery(".tek-flex-item :not(.link-sets)").css("color", "#696969");
      jQuery(".prod-essentials").hide();
      jQuery(".prod-tools").hide();
      jQuery(".prod-sets").show();
    });
    jQuery(".link-essentials").click(function(){
     jQuery(this).css("color", "#795D50");
      jQuery(".tek-flex-item :not(.link-essentials)").css("color", "#696969");
      jQuery(".prod-essentials").show();
      jQuery(".prod-tools").hide();
      jQuery(".prod-sets").hide();
    });
    jQuery(".link-tools").click(function(){
      jQuery(this).css("color", "#795D50");
      jQuery(".tek-flex-item :not(.link-tools)").css("color", "#696969");
      jQuery(".prod-essentials").hide();
      jQuery(".prod-tools").show();
      jQuery(".prod-sets").hide();
    });

});



/*AFTER FIXING CSS*/

jQuery(document).ready(function(){
jQuery('#irie-power-face-oil .productView-image-wrapper, [data-product-id="8402242175297"] .card-product__wrapper').prepend('<div class="productView-badge badge-left halo-productBadges halo-productBadges--right date- date1-" data-new-badge-number=""><span style="background-color:#C5B358" class="badge sale-badge" aria-hidden="true">AWARD WINNER</span></div>');
jQuery('#day-night-face-towel-set-set-of-6 .productView-image-wrapper, [data-product-id="8430618607937"] .card-product__wrapper').prepend('<div class="productView-badge badge-left halo-productBadges halo-productBadges--right date- date1-" data-new-badge-number=""><span style="background-color:#C5B358" class="badge sale-badge" aria-hidden="true">AWARD WINNER</span></div>');
jQuery('#soursop-vitamin-c-serum .productView-image-wrapper, [data-product-id="8682955538753"] .card-product__wrapper').prepend('<div class="productView-badge badge-left halo-productBadges halo-productBadges--right date- date1-" data-new-badge-number=""><span style="background-color:#C5B358" class="badge sale-badge" aria-hidden="true">AWARD WINNER</span></div>');
jQuery('#pava-exfoliating-cleanser .productView-image-wrapper, [data-product-id="8402241814849"] .card-product__wrapper').prepend('<div class="productView-badge badge-left halo-productBadges halo-productBadges--right date- date1-" data-new-badge-number=""><span style="background-color:#C5B358" class="badge sale-badge" aria-hidden="true">AWARD WINNER</span></div>');
jQuery('#coffee-fix-eye-cream .productView-image-wrapper, [data-product-id="9814350299457"] .card-product__wrapper').prepend('<div class="productView-badge badge-left halo-productBadges halo-productBadges--right date- date1-" data-new-badge-number=""><span style="background-color:#C5B358" class="badge sale-badge" aria-hidden="true">AWARD WINNER</span></div>');
jQuery('#good-youth-retinol-sleep-serum .productView-image-wrapper, [data-product-id="8996627775809"] .card-product__wrapper').prepend('<div class="productView-badge badge-left halo-productBadges halo-productBadges--right date- date1-" data-new-badge-number=""><span style="background-color:#C5B358" class="badge sale-badge" aria-hidden="true">AWARD WINNER</span></div>');
// jQuery('#lip-treatment .productView-image-wrapper, [data-product-id="9955651354945"] .card-product__wrapper').prepend('<div class="productView-badge badge-left halo-productBadges halo-productBadges--right date- date1-" data-new-badge-number=""><span style="background-color:#C5B358" class="badge sale-badge" aria-hidden="true">AWARD WINNER</span></div>');
});





jQuery(document).ready(function(){
 jQuery('.tek-category-section a.image-zoom').attr('target','_self');
});



function triggerSearch() {
   
    const searchIcon = $('[class*="section-header-"] .search-icon');
    
    const clickEvent = new jQuery.Event('click');
    
    clickEvent.preventDefault = function() {};
    clickEvent.stopPropagation = function() {};
    
    searchIcon.trigger(clickEvent);
    
    // Add the class and set z-index as in the original code
   // searchIcon.closest('[class*="section-header-"]').addClass('sticky-search-menu-open');
    //searchIcon.closest('.section-header-navigation').css('z-index', '101');
    // Set the 'open' attribute on the search details
 
      setTimeout(function() {
    $('.sj_header').addClass('sticky-search-menu-open'); 
     $('body').addClass('open_searchbar');     
         $('.search_details').attr('open', 'true');
     }, 50);
}
/*

  
// Function to programmatically trigger the search
function triggerSearch() {
    // Find the search icon element
    const searchIcon = $('[data-search-menu-sticky-form] .icon-search');
    
    // Create a new click event
    const clickEvent = new jQuery.Event('click');
    
    // Set properties to match the original event handling
    clickEvent.preventDefault = function() {};
    clickEvent.stopPropagation = function() {};
    
    // Trigger the event on the search icon
    searchIcon.trigger(clickEvent);
    
    // Add the class and set z-index as in the original code
    if ($('.sj_header .header-nav-plain .search_details').length) {
      console.log('ni am i');
        $('.search_details').attr('open', 'true');
         $('.search_details.search_details--popup.header--icon-border').attr('open', 'true');
        $('.sj_header').addClass('sticky-search-menu-open');
        $('.sj_header').css('z-index', '101');
    }else{
       // searchIcon.closest('[class*="section-header-navigation shopify-section-header-sticky"]').addClass('sticky-search-menu-open');
       // searchIcon.closest('.section-header-navigation').css('z-index', '101');
        // Set the 'open' attribute on the search details
        $('.search_details').attr('open', 'true');
    }
   
}*/
jQuery(".link-tools").click(function(){
      
    });

$(document).on('click', '.announcement-bar-right .search_bar', function(e){
console.log('click');
    triggerSearch();
   
});

// Call this function whenever you want to trigger the search programmatically
 


// fast code
jQuery(document).ready(function(){
    if(jQuery(window).width() > 768) {
      setTimeout(function(){
          if(jQuery("#rbr-container-element-false").length > 0){
          //  jQuery(".template-product .productView-details .product-form__submit").css({"margin-top":"-330px"});
            jQuery('#view-offer-btn').css({"display":"block"});
           // jQuery(".product-form__buttons").css({"display":"block"});
          }
      },4000);
    }
    jQuery('#view-offer-btn').click(function(){
      jQuery("div[class^='style_footer']").css({"display":"block"});
      jQuery("div[class^='style_mainSection']").css({"display":"flex"});
      jQuery("body").addClass("open-match");
    });
    jQuery('#close-mix').click(function(){
      jQuery("div[class^='style_footer'],div[class^='style_mainSection']").css({"display":"none"});
      jQuery("body").removeClass("open-match");
    });
});

/*Removing class from level 2 to make it clickable*/
function removeMobileLinkClass() {
  const menuLinks = document.querySelectorAll('a.site-nav-title');

  if (window.innerWidth < 1024) {
    menuLinks.forEach(link => {
      if (link.classList.contains('menu_mobile_link_2')) {
        link.classList.remove('menu_mobile_link_2');
      }
    });
  }
}

// Run when DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
  removeMobileLinkClass();
});

// Banner limited offer text 
jQuery(document).ready(function(){
  jQuery('.sum_sale .slide-button.button').after('<div class="end_date">Limited Time Only</div>');
});

// EventListener to remove lineitems from we may also know

/*if (cart_anchor) {
  cart_anchor.addEventListener('click', () => {
    console.log('clicked');

        // Step 1: Get cart items safely
        const cartList = document.querySelector('.sjCartList');
        if (!cartList) {
          console.warn('Cart list (.sjCartList) not found.');
          return;
        }
      
        const cartItems = cartList.querySelectorAll('li[item-product-data]');
        if (cartItems.length === 0) {
          console.warn('No cart items with item-product-data found.');
          return;
        }
      
        const cartItemIds = Array.from(cartItems)
          .map(item => item.getAttribute('item-product-data'))
          .filter(id => id); // filter out null or empty values
      
        if (cartItemIds.length === 0) {
          console.warn('Cart item IDs are empty or invalid.');
          return;
        }
      
        // Step 2: Get preview product section safely
        const previewSection = document.querySelector('.previewCartProduct');
        if (!previewSection) {
          console.warn('Preview cart product section (.previewCartProduct) not found.');
          return;
        }
      
        const previewProducts = previewSection.querySelectorAll('.product[related-data]');
        if (previewProducts.length === 0) {
          console.warn('No preview products with related-data found.');
          return;
        }
      
        // Step 3: Loop and hide matched products
        previewProducts.forEach(product => {
          const relatedId = product.getAttribute('related-data');
          if (!relatedId) {
            console.warn('A product is missing related-data attribute:', product);
            return;
          }
      
          if (cartItemIds.includes(relatedId)) {
            product.style.display = 'none';
            console.log(`Product with related-data=${relatedId} hidden because it exists in the cart.`);
          }
        });
    
  });
} else {
  console.warn('Cart anchor not found.');
} */

const cart_anchor = document.querySelector(".web-announcement-bar a[data-cart-sidebar='']");
const body = document.querySelector('body');

if (body) {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        const classList = mutation.target.classList;

        if (classList.contains('cart-sidebar-show')) {
          console.log('cart-sidebar-show class added to body!');
          // Run your function here
           setTimeout(() => {
            removeSameProducts();
          }, 1200);
        }
      }
    });
  });

  observer.observe(body, { attributes: true });
} else {
  console.warn('<body> not found!');
}

// Your function
function removeSameProducts() {
  console.log('Cart sidebar is now visible!');
  // Step 1: Get cart items safely
        const cartList = document.querySelector('.sjCartList');
        if (!cartList) {
          console.warn('Cart list (.sjCartList) not found.');
          return;
        }
      
        const cartItems = cartList.querySelectorAll('li[item-product-data]');
        if (cartItems.length === 0) {
          console.warn('No cart items with item-product-data found.');
          return;
        }
      
        const cartItemIds = Array.from(cartItems)
          .map(item => item.getAttribute('item-product-data'))
          .filter(id => id); // filter out null or empty values
      
        if (cartItemIds.length === 0) {
          console.warn('Cart item IDs are empty or invalid.');
          return;
        }
      
        // Step 2: Get preview product section safely
        const previewSection = document.querySelector('.previewCartProduct');
        if (!previewSection) {
          console.warn('Preview cart product section (.previewCartProduct) not found.');
          return;
        }
      
        const previewProducts = previewSection.querySelectorAll('.product[related-data]');
        if (previewProducts.length === 0) {
          console.warn('No preview products with related-data found.');
          return;
        }
      
        // Step 3: Loop and hide matched products
        previewProducts.forEach(product => {
          const relatedId = product.getAttribute('related-data');
          if (!relatedId) {
            console.warn('A product is missing related-data attribute:', product);
            return;
          }
      
          if (cartItemIds.includes(relatedId)) {
            product.style.display = 'none';
            console.log(`Product with related-data=${relatedId} hidden because it exists in the cart.`);
          }
        });
}